import React from "react";
import "./SpacesForHealing.css";

const SpacesForHealing: React.FC = () => {
  const leftPointers = [
    "Overthinking and Anxiety",
    "Stress management",
    "Depression/ low mood",
    "Work pressure/ Corporate related stress",
  ];

  const rightPointers = [
    "Life transitions and Adjustment concerns",
    "Interpersonal issues/ Relationship challenges",
    "Grief and Bereavement",
    "Self exploration and strengthening self-worth",
  ];

  return (
    <section id="spaces-healing" className="spaces-healing-section">
      <div className="spaces-healing-container">
        <h2 className="section-heading">Spaces for Healing and Growth</h2>
        <div className="pointers-grid">
          <div className="pointers-left">
            {leftPointers.map((pointer, index) => (
              <div
                key={index}
                className="pointer-item"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* <div className="pointer-icon"></div> */}
                <p className="pointer-text">{pointer}</p>
              </div>
            ))}
          </div>
          <div className="pointers-right">
            {rightPointers.map((pointer, index) => (
              <div
                key={index}
                className="pointer-item"
                style={{ animationDelay: `${(index + 3) * 0.1}s` }}
              >
                {/* <div className="pointer-icon">✨</div> */}
                <p className="pointer-text">{pointer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpacesForHealing;
